import Input from './Input';
import Button from './Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

function TextInputSection({ variant = 'black', text = '', placeholder = '', onChange = () => {}, sectionHeader }) {
    const isVariantWhite = variant == 'white';
    return (
        <div className="mt-5">
            {sectionHeader ? <div className={'font-medium text-12 ' + (isVariantWhite ? 'text-black' : 'text-layer-grey')}>{sectionHeader}</div> : null}
            <Input
                onChange={onChange}
                className={
                    'bg-transparent my-2 placeholder-disabled-grey outline-none border-b w-full ' + (isVariantWhite ? 'border-b-black' : 'border-b-white')
                }
                placeholder={placeholder}
                value={text}
            />
        </div>
    );
}

export default function Modal({
    title,
    variant = 'black',
    subHeader = null,
    onClickProceed = () => {},
    onCancel = () => {},
    proceedText,
    cancelText = '',
    children,
}) {
    const isVariantWhite = variant == 'white';

    return (
        <div className="fixed inset-0 bg-overlay z-50 flex flex-wrap justify-center content-center">
            <div className={'py-7 px-10 relative shadow-line-number w-[500px] ' + (isVariantWhite ? 'bg-white text-black' : 'bg-black text-white ')}>
                <FontAwesomeIcon className="cursor-pointer text-22 absolute right-3 top-2" icon={['fal', 'times']} onClick={onCancel} />
                {title ? <div className="font-medium text-20">{title}</div> : null}

                {subHeader && <div>{subHeader}</div>}

                {children}
                {proceedText ? (
                    <div className="text-right">
                        <Button
                            className={
                                'text-20 border inline-block py-2 px-9 cursor-pointer transition-all duration-300 hover:brightness-75 ' +
                                (isVariantWhite ? 'border-black' : 'border-white')
                            }
                            onClick={onClickProceed}
                        >
                            {proceedText}
                        </Button>
                    </div>
                ) : null}
            </div>
        </div>
    );
}
